<template>
    <div v-if="ativo" class="contador-sessao" :class="classeCor" :title="tooltipTexto">
        <i class="las la-clock"></i>
        <span class="contador-sessao-texto contador-sessao-texto-full">{{ textoFormatado }}</span>
        <span class="contador-sessao-texto contador-sessao-texto-curto">{{ textoFormatadoCompacto }}</span>
    </div>
</template>

<script>
export default {
    name: 'ContadorSessao',
    data () {
        return {
            restanteSegundos:   0,
            totalSegundos:      0,
            interval:           null,
            tooltipTexto:       "Sua sessão expira por inatividade. Cada interação reinicia o contador."
        }
    },
    computed: {
        politicaSessao: function() {
            var self = this;
            var pol  = self.$root && self.$root.config ? self.$root.config['politica-seguranca'] : null;
            if (!pol || !pol.sessao) {
                return null;
            }
            return pol.sessao;
        },
        minutosConfigurados: function() {
            var self = this;
            if (!self.politicaSessao || !self.politicaSessao.expiracaoPorTipo) {
                return 0;
            }
            if (!self.$root.user || !self.$root.user.tipo) {
                return 0;
            }
            var min = self.politicaSessao.expiracaoPorTipo[self.$root.user.tipo];
            return (typeof min === "number" && min > 0) ? min : 0;
        },
        enforceAtivo: function() {
            return this.politicaSessao ? this.politicaSessao.enforceAtivo !== false : false;
        },
        ativo: function() {
            var self = this;
            if (!self.$root.logged) {
                return false;
            }
            if (!self.enforceAtivo) {
                return false;
            }
            if (self.minutosConfigurados <= 0) {
                return false;
            }
            return self.restanteSegundos > 0;
        },
        classeCor: function() {
            var self = this;
            if (self.totalSegundos <= 0) {
                return "contador-sessao-verde";
            }
            if (self.restanteSegundos < 5 * 60) {
                return "contador-sessao-vermelho";
            }
            var metade = self.totalSegundos / 2;
            if (self.restanteSegundos <= metade) {
                return "contador-sessao-amarelo";
            }
            return "contador-sessao-verde";
        },
        textoFormatado: function() {
            var self      = this;
            var s         = self.restanteSegundos;
            if (s < 60) {
                var ss = s % 60;
                var mm = Math.floor(s / 60);
                return mm + ":" + (ss < 10 ? "0" + ss : ss);
            }
            var minutos = Math.floor(s / 60);
            if (minutos >= 60) {
                var horas      = Math.floor(minutos / 60);
                var minutosRem = minutos % 60;
                return "Sessão: " + horas + "h " + minutosRem + "min";
            }
            return "Sessão: " + minutos + "min";
        },
        // Versão curta usada em mobile (sem prefixo "Sessão:")
        textoFormatadoCompacto: function() {
            var s = this.restanteSegundos;
            if (s < 60) {
                var ss = s % 60;
                var mm = Math.floor(s / 60);
                return mm + ":" + (ss < 10 ? "0" + ss : ss);
            }
            var minutos = Math.floor(s / 60);
            if (minutos >= 60) {
                return Math.floor(minutos / 60) + "h" + (minutos % 60 ? (minutos % 60) + "m" : "");
            }
            return minutos + "m";
        }
    },
    methods: {
        resetar: function() {
            var self = this;
            var min  = self.minutosConfigurados;
            if (min <= 0) {
                self.totalSegundos    = 0;
                self.restanteSegundos = 0;
                return;
            }
            self.totalSegundos    = min * 60;
            self.restanteSegundos = self.totalSegundos;
        },
        // Sincroniza o contador com o valor REAL do servidor (header X-Session-Restante).
        // Chamado pelo interceptor axios via $emit('session-synced', { restanteSegundos, totalSegundos }).
        sincronizar: function (payload) {
            var self = this;
            if (!payload || typeof payload.restanteSegundos !== "number") return;
            if (typeof payload.totalSegundos === "number" && payload.totalSegundos > 0) {
                self.totalSegundos = payload.totalSegundos;
            }
            self.restanteSegundos = Math.max(0, payload.restanteSegundos);
        },
        tick: function() {
            var self = this;
            if (!self.$root.logged) {
                self.restanteSegundos = 0;
                return;
            }
            if (self.minutosConfigurados <= 0 || !self.enforceAtivo) {
                self.restanteSegundos = 0;
                return;
            }
            if (self.restanteSegundos > 0) {
                self.restanteSegundos -= 1;
            }
        }
    },
    watch: {
        "$root.user.tipo": function() {
            this.resetar();
        },
        "$root.logged": function(val) {
            if (val) {
                this.resetar();
            } else {
                this.restanteSegundos = 0;
            }
        },
        minutosConfigurados: function() {
            this.resetar();
        }
    },
    mounted: function() {
        var self = this;
        self.resetar();
        if (self.$root && typeof self.$root.$on === "function") {
            self.$root.$on('session-renewed', self.resetar);
            self.$root.$on('session-synced',  self.sincronizar);
        }
        self.interval = setInterval(self.tick, 1000);
    },
    beforeDestroy: function() {
        var self = this;
        if (self.$root && typeof self.$root.$off === "function") {
            self.$root.$off('session-renewed', self.resetar);
            self.$root.$off('session-synced',  self.sincronizar);
        }
        if (self.interval) {
            clearInterval(self.interval);
            self.interval = null;
        }
    }
}
</script>

<style scoped>
    .contador-sessao {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 5px 10px;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
        background: rgba(255,255,255,0.12);
        border: 1px solid rgba(255,255,255,0.18);
        white-space: nowrap;
        cursor: help;
        user-select: none;
    }
    .contador-sessao i {
        font-size: 14px;
    }
    .contador-sessao-verde {
        color: #2e7d32;
        background: #e8f5e9;
        border-color: #c8e6c9;
    }
    .contador-sessao-amarelo {
        color: #ef6c00;
        background: #fff3e0;
        border-color: #ffe0b2;
    }
    .contador-sessao-vermelho {
        color: #c62828;
        background: #ffebee;
        border-color: #ffcdd2;
        animation: contador-sessao-pulse 1.5s ease-in-out infinite;
    }
    @keyframes contador-sessao-pulse {
        0%, 100% { opacity: 1; }
        50%      { opacity: 0.65; }
    }

    /* Desktop mostra o texto longo ("Sessão: 28min"); mobile mostra só o compacto ("28m") */
    .contador-sessao-texto-curto { display: none; }
    .contador-sessao-texto-full  { display: inline; }
    @media (max-width: 991px) {
        /* Em mobile, o contador "salta" do header e fica abaixo do avatar,
           pra não sobrepor o título da página. O pai (.top-right-compact em
           Top.vue) tem position:relative pra ancorar o absolute aqui. */
        .contador-sessao {
            position: absolute;
            top: calc(100% + 2px);
            right: 0;
            padding: 2px 8px;
            font-size: 10px;
            gap: 3px;
            border-radius: 999px;
            line-height: 1.2;
            background: rgba(255,255,255,0.95);
            box-shadow: 0 2px 6px rgba(0,0,0,0.18);
            z-index: 10;
        }
        .contador-sessao i {
            font-size: 11px;
        }
        .contador-sessao-texto-full  { display: none; }
        .contador-sessao-texto-curto { display: inline; }
    }
</style>



// WEBPACK FOOTER //
// src/components/ContadorSessao.vue